import z from 'zod';
const STRIPE_INVOICE_ID_PREFIX = 'in_';
export const stripeInvoiceIdValue = z
    .string()
    .trim()
    .refine(value => value.startsWith(STRIPE_INVOICE_ID_PREFIX), {
    message: 'Invalid stripe invoice id format',
})
    .brand('StripeInvoiceId');
export const createStripeInvoiceId = (value) => stripeInvoiceIdValue.parse(value);
export const isStripeInvoiceId = (value) => stripeInvoiceIdValue.safeParse(value).success;
//# sourceMappingURL=stripe-invoice-id.js.map